<template>
  <div class="admin">
    <SignUpPage></SignUpPage>
  </div>
</template>

<script>
import SignUpPage from '@/components/SignUpPage.vue';

export default {
  name: 'adminView',
  components: {
    SignUpPage
  }
}
</script>
